import { render, staticRenderFns } from "./PatientRegistry.vue?vue&type=template&id=5420ef05&scoped=true&lang=pug"
import script from "./PatientRegistry.vue?vue&type=script&lang=js"
export * from "./PatientRegistry.vue?vue&type=script&lang=js"
import style0 from "./PatientRegistry.vue?vue&type=style&index=0&id=5420ef05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5420ef05",
  null
  
)

export default component.exports